import { useEffect } from "react";
import useHistory from "routing/useHistory";
import AWSCloudTrailRoutes from "./common/Routes";
const CloudTrailInputConfiguration = () => {
  const history = useHistory();
  useEffect(() => {
    const url = AWSCloudTrailRoutes.INTEGRATIONS.AWSCloudTrail.ACTIVITYAPI.index;
    history.push(url);
  }, [history]);
  return null;
};
export default CloudTrailInputConfiguration;
